// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1ZYPx","col":"styles_col__3AcjX"};